import angular from 'angular';
import currencyConvertion from './currencyConvertion';

export default angular
  .module('components.currencyConvertion', [])
  .component('currencyConvertion', currencyConvertion).name;
